import { getWidthOrHeight } from './panelEdgeOrientation.js';

function interpolate(p1, p2, t) {
  return [p1[0] + (p2[0] - p1[0]) * t, p1[1] + (p2[1] - p1[1]) * t];
}

/** 닫힌 링(5점)이면 앞 4꼭짓점만 사용 */
export function getQuadCorners(ring) {
  if (!ring?.length) {
    return [];
  }
  if (ring.length >= 5) {
    const first = ring[0];
    const last = ring[ring.length - 1];
    if (first[0] === last[0] && first[1] === last[1]) {
      return ring.slice(0, 4).map(c => [...c]);
    }
  }
  return ring.slice(0, 4).map(c => [...c]);
}

/** moduleRowNum(↕) × moduleColNum(↔) 격자에서 (i,j) 셀 꼭짓점 */
export function getModuleCellCorners(
  arr1,
  arr2,
  arr3,
  arr4,
  moduleRowNum,
  moduleColNum,
  i,
  j
) {
  const [A, B, C, D] = [arr1, arr2, arr3, arr4];
  const firstTwoPointsDirection = getWidthOrHeight(A, B);

  if (firstTwoPointsDirection.type === 'width') {
    const topStart = interpolate(A, B, j / moduleColNum);
    const topEnd = interpolate(A, B, (j + 1) / moduleColNum);
    const bottomStart = interpolate(D, C, j / moduleColNum);
    const bottomEnd = interpolate(D, C, (j + 1) / moduleColNum);

    const topLeft = interpolate(topStart, bottomStart, i / moduleRowNum);
    const topRight = interpolate(topEnd, bottomEnd, i / moduleRowNum);
    const bottomRight = interpolate(topEnd, bottomEnd, (i + 1) / moduleRowNum);
    const bottomLeft = interpolate(topStart, bottomStart, (i + 1) / moduleRowNum);

    return [topLeft, topRight, bottomRight, bottomLeft];
  }

  const leftStart = interpolate(A, D, i / moduleRowNum);
  const leftEnd = interpolate(A, D, (i + 1) / moduleRowNum);
  const rightStart = interpolate(B, C, i / moduleRowNum);
  const rightEnd = interpolate(B, C, (i + 1) / moduleRowNum);

  const topLeft = interpolate(leftStart, rightStart, j / moduleColNum);
  const topRight = interpolate(leftEnd, rightEnd, j / moduleColNum);
  const bottomRight = interpolate(leftEnd, rightEnd, (j + 1) / moduleColNum);
  const bottomLeft = interpolate(leftStart, rightStart, (j + 1) / moduleColNum);

  return [topLeft, topRight, bottomRight, bottomLeft];
}

/**
 * dividePolygon 루프 — 백업 getCellCorners 호출 규칙
 * 첫 변이 세로(height)면 row/col·i/j 를 교환해 호출 (PanelPlanningPage.vue.backup)
 */
export function getModuleCellCornersForDivide(
  arr1,
  arr2,
  arr3,
  arr4,
  moduleRowNum,
  moduleColNum,
  i,
  j
) {
  const firstEdge = getWidthOrHeight(arr1, arr2);
  if (firstEdge.type === 'height') {
    return getModuleCellCorners(arr1, arr2, arr3, arr4, moduleColNum, moduleRowNum, j, i);
  }
  return getModuleCellCorners(arr1, arr2, arr3, arr4, moduleRowNum, moduleColNum, i, j);
}
